module.exports = __webpack_public_path__ + "static/Wikigrads-71ae4fcd9b8d5af5e677a8402457b497.svg";